<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />

    <DataTable
      v-show="mostrarSkeleton == false"
      :tableTitle="'Dispensas Teste Rápido'"
      :tableHeader="headers"
      :tableRows="listaDispensasKit"
      :totalItens="total"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
      :newRowmodalButtonText="'Nova Dispensa'"
      :isEdit="false"
      :isViewEdit="true"
      :isDevolucao="true"
      v-on:datatable-newrow="modalDeInserir"
      v-on:datatable-updaterow="modalDeAtualizar"
      v-on:datatable-viewrow="modalDeVisualizar"
      v-on:datatable-devolucao="modalDeExcluir"
    ></DataTable>

    <SkeletonTable v-show="mostrarSkeleton == true" :showSkeletonTable="mostrarSkeleton"></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="acoesModal"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>
      </v-row>

      <v-form v-model="tudoValido">
        <v-row>
          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.dadosModal.responsavelDispensa" label="Responsável Dispensa" autocomplete="off" disabled></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :disabled="modalCustomSize.isView"
                  v-on="on"
                  v-model="modalCustomSize.dadosModal.dataDispensaFormatada"
                  label="Data dispensa"
                  hint="DD/MM/AAAA"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  autocomplete="off"
                  v-mask="['##/##/####']"
                  :rules="[rules.requerido]"
                  @blur="modalCustomSize.dadosModal.dataDispensa = analizarData(modalCustomSize.dadosModal.dataDispensaFormatada)"
                ></v-text-field>
              </template>
              <v-date-picker v-model="modalCustomSize.dadosModal.dataDispensa" no-title @input="menu = false" @change="modalCustomSize.dadosModal.dataDispensaFormatada = formatarData(modalCustomSize.dadosModal.dataDispensa)"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" v-if="!modalCustomSize.isView">
            <v-text-field prepend-icon="mdi-account-search" @click:prepend="buscarPessoa" v-model="modalCustomSize.dadosModal.descricaoCpf" name="cpf" label="Buscar CPF para iniciar a dispensa" v-mask="['###.###.###-##']" :rules="[rules.requerido]" autocomplete="off"></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="mostrarDadosPaciente">
          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.dadosModal.descricaoNome" label="Nome do paciente" autocomplete="off" :rules="[rules.requerido]" :disabled="modalCustomSize.isView || modalCustomSize.dadosModal.descricaoCpf == '555.555.555-55'"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSize.dadosModal.dataNascimentoFormatada"
              label="Data de nascimento"
              autocomplete="off"
              v-mask="['##/##/####']"
              :rules="dataRules"
              @blur="modalCustomSize.dadosModal.dataNascimento = analizarData(modalCustomSize.dadosModal.dataNascimentoFormatada)"
              :disabled="modalCustomSize.isView || modalCustomSize.dadosModal.descricaoCpf == '555.555.555-55'"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="py-1">
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field v-model="modalCustomSize.dadosModal.descricaoDispensa" label="Descrição da Dispensa" autocomplete="off" :rules="[rules.requerido]" :disabled="modalCustomSize.isView"></v-text-field>
          </v-col>

          <v-col cols="12" v-if="!modalCustomSize.isView">
            <v-autocomplete label="Lista de Produtos" :items="listaDeMateriais" v-model="itemSelecionado"></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-data-table :headers="modalCustomSize.isView ? headersItensVisualizar : headersItens" :search="searchItemDispensa" :items="modalCustomSize.dadosModal.produtosDispensados" disable-sort>
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>

              <template v-slot:[`item.validade`]="{ item }">
                <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
              </template>

              <template v-slot:[`item.indicadorDefeito`]="props">
                <v-checkbox v-model="props.item.indicadorDefeito" :false-value="0" :true-value="1" color="success" :disabled="modalCustomSize.isView"></v-checkbox>
              </template>

              <template v-slot:[`item.indicadorPerdido`]="props">
                <v-checkbox v-model="props.item.indicadorPerdido" :false-value="0" :true-value="1" color="success" :disabled="modalCustomSize.isView"></v-checkbox>
              </template>

              <template v-slot:[`item.indicadorGravidez`]="props">
                <v-checkbox v-model="props.item.indicadorGravidez " :value="props.item.indicadorGravidez"  :false-value="0" :true-value="1" color="success" :disabled="modalCustomSize.isView || props.item.indicadorTipo == 6"></v-checkbox>
              </template>

              <template v-slot:[`item.indicadorResultado`]="props">
                <span v-if="props.item.indicadorTipo == 6"> HIV DUO </span>
                  <v-radio-group v-model="props.item.indicadorResultado" row :disabled="modalCustomSize.isView">
                    <v-radio label="Negativo" :value="0"></v-radio>
                    <v-radio label="Positivo" :value="1"></v-radio>
                  </v-radio-group>

                  <span v-if="props.item.indicadorTipo == 6"> SIFILIS DUO </span>
                  <v-radio-group v-if="props.item.indicadorTipo == 6" v-model="props.item.indicadorResultado2" row :disabled="modalCustomSize.isView">
                    <v-radio label="Negativo" :value="0"></v-radio>
                    <v-radio label="Positivo" :value="1"></v-radio>
                  </v-radio-group>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip v-if="!modalCustomSize.isView" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small @click="removerItemDaLista(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>

                <v-tooltip v-if="modalCustomSize.isView" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small @click="modalDeExcluirItem(item)" v-bind="attrs" v-on="on">
                      mdi-refresh-circle
                    </v-icon>
                  </template>
                  <span>Devolução de Produto</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>

    <DeleteItemModal :showModalDelete="modalDelete.abrir" :textModalDelete="modalDelete.texto" :buttomTextModalDelete="'Devolver'" v-on:close-modal="modalDelete.abrir = false" v-on:on-response-modal-delete="excluir"></DeleteItemModal>

    <DeleteItemModal :showModalDelete="modalDeleteItem.abrir" :textModalDelete="modalDeleteItem.texto" :buttomTextModalDelete="'Devolver'" v-on:close-modal="modalDeleteItem.abrir = false" v-on:on-response-modal-delete="excluirItem"></DeleteItemModal>
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";
import DataTable from "@/components/DataTable2.vue";
import SkeletonTable from "../components/SkeletonTable";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";

export default {
  components: {
    Alertas,
    AlertasModal,
    AlertaSnackbar,
    DataTable,
    SkeletonTable,
    Loading,
    ModalCustomSize,
    DeleteItemModal,
  },

  data: () => ({
    //#region Paginação
    page: 1,
    search: null,
    total: null,
    searchItemDispensa: null,
    //#endregion

    //#region Alertas
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },
    //#endregion

    rules: {
      requerido: (value) => (value != null && value != "") || "Requer o campo!",
    },

    dataRules: [
      (v) => !!v || "Data obrigatória!",
      (v) => !v || /^\d{2}\/\d{2}\/\d{4}$/.test(v) || "Data contêm formato inválido! Utilize o formato DD/MM/AAAA.",
      (v) => {
        if (!v) return true;
        const parts = v.split(" ");
        const date = parts[0];
        const [day, month, year] = date.split("/");
        const isValidDate = (month == 2 ? day >= 1 && day <= 28 : day >= 1 && day <= 31) && month >= 1 && month <= 12 && year.length === 4 && year >= 1900;
        return isValidDate || "Data inválida!";
      },
    ],

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    headers: [
      {
        text: "ID",
        value: "dispensaKit.numeroDispensaKit",
      },
      {
        text: "Descrição Dispensa",
        value: "dispensaKit.descricaoDispensa",
      },
      {
        text: "Dispensado Para",
        value: "dispensadoParaTelaKit",
      },
      {
        text: "Data Dispensa",
        value: "dispensaKit.dataDispensa",
      },
      {
        text: "Responsável",
        value: "funcionario.nomeFuncionario",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "numeroItem",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Produto",
        value: "nomeItem",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Perdido",
        value: "indicadorPerdido",
      },
      {
        text: "Teste Inválido",
        value: "indicadorDefeito",
      },
      {
        text: "Gestante",
        value: "indicadorGravidez",
      },
      {
        text: "Resultado",
        value: "indicadorResultado",
      },
      {
        text: "Qt. Dispensada",
        value: "quantidadeDispensada",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensVisualizar: [
      {
        text: "ID",
        value: "numeroItemDispensaKit",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Produto",
        value: "nomeItem",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Perdido",
        value: "indicadorPerdido",
      },
      {
        text: "Teste Inválido",
        value: "indicadorDefeito",
      },
      {
        text: "Gestante",
        value: "indicadorGravidez",
      },
      {
        text: "Resultado",
        value: "indicadorResultado",
      },
      {
        text: "Qt. Dispensada",
        value: "quantidadeDispensada",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    modalCustomSize: {
      size: "1600",
      isOpen: false,
      isEdit: false,
      isView: false,
      formTitle: "",
      buttonText: "Concluir",
      isButtonsVisible: false,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      dadosModal: {
        numeroDispensaKit: null,
        numeroEndereco: store.state.numeroEndereco,
        responsavelDispensa: store.state.nome,
        descricaoDispensa: null,
        dataDispensa: null,
        dataDispensaFormatada: null,

        numeroPaciente: null,
        descricaoCpf: null,
        descricaoNome: null,
        dataNascimento: null,
        descricaoTelefone: null,
        descricaoEndereco: null,

        produtosDispensados: [],
        produtosDispensadosExcluidos: [],
      },
    },

    modalDelete: {
      abrir: false,
      texto: "Você realmente deseja devolver essa dispensa?",
      dadosDelete: {
        numeroDispensaKit: null,
        dataDispensa: null,
      },
    },

    modalDeleteItem: {
      abrir: false,
      texto: "Você realmente deseja devolver esse produto da dispensa?",
      dadosDelete: {
        numeroDispensaKit: null,
        numeroItemDispensaKit: null,
        numeroItemUnidade: null,
        quantidadeAtual: null,
        dataDispensa: null,
      },
    },

    menu: false,
    loading: false,
    tudoValido: false,
    mostrarSkeleton: true,

    mostrarDadosPaciente: false,
    liberarFormulario: false,

    itemSelecionado: null,

    listaDispensasKit: [],
    listaDeMateriais: [],
  }),

  created() {
    this.mostrarSkeleton = true;
    this.gerarNovoToken();
  },

  watch: {
    tudoValido() {
      this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
    },

    async "modalCustomSize.dadosModal.descricaoCpf"() {
      if (this.modalCustomSize.dadosModal.descricaoCpf != null && this.modalCustomSize.dadosModal.descricaoCpf.length == 14) {
        await this.buscarPessoa();
      } else {
        this.modalCustomSize.dadosModal.descricaoNome = null;
        this.modalCustomSize.dadosModal.dataNascimento = null;
        this.modalCustomSize.dadosModal.numeroPaciente = null;
        this.liberarFormulario = false;
      }
    },

    itemSelecionado() {
      if (this.itemSelecionado) {
        const verificarItem = this.modalCustomSize.dadosModal.produtosDispensados.filter((item) => item.numeroItem == this.itemSelecionado);  
        if (verificarItem.length <= 0) {
          const itemInsert = this.listaDeMateriais.filter((item) => item.numeroItem == this.itemSelecionado);
          this.modalCustomSize.dadosModal.produtosDispensados.unshift(itemInsert[0]);
          this.itemSelecionado = "";
        } else {
          this.alertaModal.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaSnackbar.mostrar = true;
        }
      }
    },
  },

  methods: {
    //#region LISTAGENS
    async inicializar() {
      try {
        const response = await axios.put("listadispensakit", { page: this.page, search: this.search, numeroUnidade: store.state.numeroEndereco }, this.config);
        if (!response.data || response.data.length > 0) {
          this.listaDispensasKit = response.data;
          this.total = response.data[0].total;
        } else {
          this.listaDispensasKit = [];
          this.total = 0;
        }
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.mostrarSkeleton = false;
      }
    },

    async updateSearch(search) {
      if (search) {
        this.search = search;
        this.page = 1;
        await this.inicializar();
      } else {
        this.page = 1;
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page;
      await this.inicializar();
    },

    async listarItensDisponiveisNaUnidade() {
      try {
        this.alertaModal.tipo = "";
        const responseItens = await axios.put("itemEstoqueUnidade", { numeroEndereco: store.state.numeroEndereco, indicadorStatusFamilia: 11, semVazios: true, naoRetornarKit: false }, this.config);
        this.listaDeMateriais = responseItens.data.map((row) => {

          if(row.itemSistema.indicadorTipo == 6){
            return {
            value: row.item.numeroItem,
            text: "Validade: " + row.item.validade + " " + row.nomeItemPadrao + " Lote: " + row.item.lote,
            numeroItemUnidade: row.itemUnidade.numeroItemUnidade,
            numeroItem: row.item.numeroItem,
            nomeItem: row.nomeItemPadrao,
            lote: row.item.lote,
            validade: row.item.validade,
            quantidadeAtual: row.itemUnidade.quantidadeEstoque,
            indicadorTipo: row.itemSistema.indicadorTipo,
            quantidadeDispensada: 1,
            indicadorDefeito: 0,
            indicadorPerdido: 0,
            indicadorGravidez: 1,
            indicadorResultado: 0,
            indicadorResultado2: 0,
            };
          }else{
            return {
              value: row.item.numeroItem,
            text: "Validade: " + row.item.validade + " " + row.nomeItemPadrao + " Lote: " + row.item.lote,
            numeroItemUnidade: row.itemUnidade.numeroItemUnidade,
            numeroItem: row.item.numeroItem,
            nomeItem: row.nomeItemPadrao,
            lote: row.item.lote,
            validade: row.item.validade,
            quantidadeAtual: row.itemUnidade.quantidadeEstoque,
            indicadorTipo: row.itemSistema.indicadorTipo,
            quantidadeDispensada: 1,
            indicadorDefeito: 0,
            indicadorPerdido: 0,
            indicadorGravidez: 0,
            indicadorResultado: 0,
          };
        }
        });
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listarProdutosDispensados(numeroDispensaKit) {
      try {
        this.alertaModal.tipo = "";
        const response = await axios.put("produtosdispensakit", { numeroDispensaKit: numeroDispensaKit }, this.config);

        return response.data;
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },
    //#endregion

    //#region EVENTOS REQUISIÇÃO
    async acoesModal() {
      try {
        this.loading = true;
        if (this.modalCustomSize.isEdit) {
          await this.atualizar();
        } else {
          await this.inserir();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async inserir() {
      try {
        this.alertaModal.tipo = "";
        await axios.post("dispensakit", this.modalCustomSize.dadosModal, this.config);

        this.alerta.texto = "Nova dispensa de teste rápido registrada com sucesso!";
        this.alerta.tipo = "sucesso";

        this.modalCustomSize.isOpen = false;
        this.mostrarSkeleton = true;
        this.inicializar();
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },

    async atualizar() {
      try {
        console.log(this.modalCustomSize.dadosModal);
        //this.alertaModal.tipo = '';
        //await axios.put('dispensakit', this.modalCustomSize.dadosModal, this.config);

        //this.alerta.texto = "Dispensa de teste rápido atualizada com sucesso!";
        //this.alerta.tipo = "sucesso";

        //this.modalCustomSize.isOpen = false;
        //this.mostrarSkeleton = true;
        //this.inicializar();
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },

    async excluir() {
      this.loading = true;
      try {
        this.alerta.tipo = "";
        await axios.delete("dispensakit", {
          data: this.modalDelete.dadosDelete,
          headers: this.config.headers,
        });

        this.alerta.texto = "Dispensa de teste rápido removido com sucesso!";
        this.alerta.tipo = "sucesso";

        this.modalDelete.abrir = false;
        this.mostrarSkeleton = true;
        this.inicializar();
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.loading = false;
      }
    },

    async excluirItem() {
      this.loading = true;
      try {
        this.alerta.tipo = "";
        this.alertaModal.tipo = "";
        const response = await axios.delete("produtodispensakit", {
          data: this.modalDeleteItem.dadosDelete,
          headers: this.config.headers,
        });

        if (response.data.dispensaExcluida == true || response.data.dispensaExcluida == "true") {
          this.alerta.texto = "Dispensa de teste rápido removido com sucesso!";
          this.alerta.tipo = "sucesso";

          this.modalDeleteItem.abrir = false;
          this.modalCustomSize.isOpen = false;
          this.mostrarSkeleton = true;
          this.inicializar();
        } else {
          this.alertaModal.texto = "Produto da dispensa devolvido com sucesso!";
          this.alertaModal.tipo = "sucesso";

          this.modalDeleteItem.abrir = false;
          this.modalCustomSize.dadosModal.produtosDispensados = await this.listarProdutosDispensados(this.modalDeleteItem.dadosDelete.numeroDispensaKit);
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.loading = false;
      }
    },
    //#endregion

    //#region FUNÇÕES MODAL
    async modalDeInserir() {
      this.loading = true;
      try {
        await this.verificarToken();

        this.alertaModal.tipo = "";

        this.itemSelecionado = null;

        await this.listarItensDisponiveisNaUnidade();

        this.modalCustomSize.dadosModal.numeroDispensaKit = null;
        this.modalCustomSize.dadosModal.descricaoDispensa = null;
        this.modalCustomSize.dadosModal.responsavelDispensa = store.state.nome;
        this.modalCustomSize.dadosModal.dataDispensa = new Date().toISOString().substr(0, 10);
        this.modalCustomSize.dadosModal.dataDispensaFormatada = this.formatarData(new Date().toISOString().substr(0, 10));

        this.modalCustomSize.dadosModal.numeroPaciente = null;
        this.modalCustomSize.dadosModal.descricaoCpf = null;
        this.modalCustomSize.dadosModal.descricaoNome = null;
        this.modalCustomSize.dadosModal.dataNascimento = null;
        this.modalCustomSize.dadosModal.dataNascimentoFormatada = null;
        this.modalCustomSize.dadosModal.descricaoTelefone = null;
        this.modalCustomSize.dadosModal.descricaoEndereco = null;
        this.mostrarDadosPaciente = false;

        this.modalCustomSize.dadosModal.produtosDispensados = [];
        this.modalCustomSize.dadosModal.produtosDispensadosExcluidos = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.formTitle = "Nova Dispensa";
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isView = false;
        this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
        this.modalCustomSize.isButtonsVisible = true;
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalDeAtualizar(dispensaSelecionada) {
      this.loading = true;
      try {
        await this.verificarToken();

        this.alertaModal.tipo = "";

        this.itemSelecionado = null;

        await this.listarItensDisponiveisNaUnidade();

        this.modalCustomSize.dadosModal.numeroDispensaKit = dispensaSelecionada.dispensaKit.numeroDispensaKit;
        this.modalCustomSize.dadosModal.descricaoDispensa = dispensaSelecionada.dispensaKit.descricaoDispensa;
        this.modalCustomSize.dadosModal.responsavelDispensa = dispensaSelecionada.funcionario.nomeFuncionario;
        this.modalCustomSize.dadosModal.dataDispensa = this.formataDataBanco(dispensaSelecionada.dispensaKit.dataDispensa);
        this.modalCustomSize.dadosModal.dataDispensaFormatada = this.formataDataBancoTipoPadrao(this.modalCustomSize.dadosModal.dataDispensa);

        if (dispensaSelecionada.paciente.numeroPaciente) {
          this.modalCustomSize.dadosModal.numeroPaciente = dispensaSelecionada.paciente.numeroPaciente;
          this.modalCustomSize.dadosModal.descricaoCpf = dispensaSelecionada.paciente.descricaoCpf;
          this.modalCustomSize.dadosModal.descricaoNome = dispensaSelecionada.paciente.descricaoNome;
          this.modalCustomSize.dadosModal.dataNascimento = this.formataDataBanco(dispensaSelecionada.paciente.dataNascimento);
          this.modalCustomSize.dadosModal.dataNascimentoFormatada = this.formataDataBancoTipoPadrao(dispensaSelecionada.paciente.dataNascimento);
          this.modalCustomSize.dadosModal.descricaoTelefone = dispensaSelecionada.paciente.descricaoTelefone;
          this.modalCustomSize.dadosModal.descricaoEndereco = dispensaSelecionada.paciente.descricaoEndereco;
          this.mostrarDadosPaciente = true;
        } else {
          this.modalCustomSize.dadosModal.numeroPaciente = null;
          this.modalCustomSize.dadosModal.descricaoCpf = null;
          this.modalCustomSize.dadosModal.descricaoNome = null;
          this.modalCustomSize.dadosModal.dataNascimento = null;
          this.modalCustomSize.dadosModal.dataNascimentoFormatada = null;
          this.modalCustomSize.dadosModal.descricaoTelefone = null;
          this.modalCustomSize.dadosModal.descricaoEndereco = null;
          this.mostrarDadosPaciente = false;
        }

        this.modalCustomSize.dadosModal.produtosDispensados = [];
        this.modalCustomSize.dadosModal.produtosDispensados = await this.listarProdutosDispensados(dispensaSelecionada.dispensaKit.numeroDispensaKit);
        this.modalCustomSize.dadosModal.produtosDispensadosExcluidos = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.formTitle = "Atualizar Dispensa";
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.isView = false;
        this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
        this.modalCustomSize.isButtonsVisible = true;
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalDeVisualizar(dispensaSelecionada) {
      this.loading = true;
      try {
        await this.verificarToken();

        this.alertaModal.tipo = "";

        this.itemSelecionado = null;

        this.modalCustomSize.dadosModal.numeroDispensaKit = dispensaSelecionada.dispensaKit.numeroDispensaKit;
        this.modalCustomSize.dadosModal.descricaoDispensa = dispensaSelecionada.dispensaKit.descricaoDispensa;
        this.modalCustomSize.dadosModal.responsavelDispensa = dispensaSelecionada.funcionario.nomeFuncionario;
        this.modalCustomSize.dadosModal.dataDispensa = this.formataDataBanco(dispensaSelecionada.dispensaKit.dataDispensa);
        this.modalCustomSize.dadosModal.dataDispensaFormatada = this.formataDataBancoTipoPadrao(this.modalCustomSize.dadosModal.dataDispensa);

        if (dispensaSelecionada.paciente.numeroPaciente) {
          this.modalCustomSize.dadosModal.numeroPaciente = dispensaSelecionada.paciente.numeroPaciente;
          this.modalCustomSize.dadosModal.descricaoCpf = dispensaSelecionada.paciente.descricaoCpf;
          this.modalCustomSize.dadosModal.descricaoNome = dispensaSelecionada.paciente.descricaoNome;
          this.modalCustomSize.dadosModal.dataNascimento = this.formataDataBanco(dispensaSelecionada.paciente.dataNascimento);
          this.modalCustomSize.dadosModal.dataNascimentoFormatada = this.formataDataBancoTipoPadrao(dispensaSelecionada.paciente.dataNascimento);
          this.modalCustomSize.dadosModal.descricaoTelefone = dispensaSelecionada.paciente.descricaoTelefone;
          this.modalCustomSize.dadosModal.descricaoEndereco = dispensaSelecionada.paciente.descricaoEndereco;
          this.mostrarDadosPaciente = true;
        } else {
          this.modalCustomSize.dadosModal.numeroPaciente = null;
          this.modalCustomSize.dadosModal.descricaoCpf = null;
          this.modalCustomSize.dadosModal.descricaoNome = null;
          this.modalCustomSize.dadosModal.dataNascimento = null;
          this.modalCustomSize.dadosModal.dataNascimentoFormatada = null;
          this.modalCustomSize.dadosModal.descricaoTelefone = null;
          this.modalCustomSize.dadosModal.descricaoEndereco = null;
          this.mostrarDadosPaciente = false;
        }

        this.modalCustomSize.dadosModal.produtosDispensados = [];
        this.modalCustomSize.dadosModal.produtosDispensados = await this.listarProdutosDispensados(dispensaSelecionada.dispensaKit.numeroDispensaKit);
        this.modalCustomSize.dadosModal.produtosDispensadosExcluidos = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.formTitle = "Visualizar Dispensa";
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isView = true;
        this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
        this.modalCustomSize.isButtonsVisible = false;
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalDeExcluir(dispensaSelecionada) {
      await this.verificarToken();

      this.modalDelete.abrir = true;
      this.modalDelete.dadosDelete.numeroDispensaKit = dispensaSelecionada.dispensaKit.numeroDispensaKit;
      this.modalDelete.dadosDelete.dataDispensa = this.formataDataBanco(dispensaSelecionada.dispensaKit.dataDispensa);
    },

    async modalDeExcluirItem(produtoSelecionado) {
      await this.verificarToken();

      this.modalDeleteItem.abrir = true;
      this.modalDeleteItem.dadosDelete.numeroDispensaKit = this.modalCustomSize.dadosModal.numeroDispensaKit;
      this.modalDeleteItem.dadosDelete.numeroItemDispensaKit = produtoSelecionado.numeroItemDispensaKit;
      this.modalDeleteItem.dadosDelete.numeroItemUnidade = produtoSelecionado.numeroItemUnidade;
      this.modalDeleteItem.dadosDelete.quantidadeAtual = produtoSelecionado.quantidadeAtual;
      this.modalDeleteItem.dadosDelete.dataDispensa = this.modalCustomSize.dadosModal.dataDispensa;
    },
    //#endregion

    //#region HANDLERS
    async buscarPessoa() {
      try {
        this.alertaModal.tipo = "";
        this.alertaSnackbar.mostrar = false;

        if (!this.modalCustomSize.isView) {
          if (this.modalCustomSize.dadosModal.descricaoCpf == "555.555.555-55") {
            this.modalCustomSize.dadosModal.numeroPaciente = 152371;
            this.modalCustomSize.dadosModal.descricaoNome = this.formatarNome("Anônimo");
            this.modalCustomSize.dadosModal.dataNascimento = "1990-01-01";
            this.modalCustomSize.dadosModal.dataNascimentoFormatada = "01/01/1990";
            this.modalCustomSize.dadosModal.descricaoTelefone = null;
            this.modalCustomSize.dadosModal.descricaoEndereco = null;

            this.mostrarDadosPaciente = true;
          } else {
            const pessoa = await axios.put("/buscarpessoa", { numeroCpf: this.modalCustomSize.dadosModal.descricaoCpf }, this.config);
            this.liberarFormulario = this.validarUnidade(store.state.numeroEndereco.toString());

            if (pessoa.data.numeroPaciente) {
              this.modalCustomSize.dadosModal.numeroPaciente = pessoa.data.numeroPaciente;
              this.modalCustomSize.dadosModal.descricaoNome = this.formatarNome(pessoa.data.descricaoNome);
              this.modalCustomSize.dadosModal.dataNascimento = this.formataDataBanco(pessoa.data.dataNascimento);
              this.modalCustomSize.dadosModal.dataNascimentoFormatada = this.formataDataBancoTipoPadrao(pessoa.data.dataNascimento);
              this.modalCustomSize.dadosModal.descricaoTelefone = pessoa.data.descricaoTelefone;
              this.modalCustomSize.dadosModal.descricaoEndereco = pessoa.data.descricaoEndereco;

              if (pessoa.data.indicadorCartao) {
                this.liberarFormulario = true;
              } else {
                this.modalCustomSize.dadosModal.numeroPaciente = pessoa.data.numeroPaciente;
                this.modalCustomSize.dadosModal.descricaoNome = this.formatarNome(pessoa.data.descricaoNome);
                this.modalCustomSize.dadosModal.dataNascimento = this.formataDataBanco(pessoa.data.dataNascimento);
                this.modalCustomSize.dadosModal.dataNascimentoFormatada = this.formataDataBancoTipoPadrao(pessoa.data.dataNascimento);
                this.modalCustomSize.dadosModal.descricaoTelefone = pessoa.data.descricaoTelefone;
                this.modalCustomSize.dadosModal.descricaoEndereco = pessoa.data.descricaoEndereco;
              }
            } else {
              this.modalCustomSize.dadosModal.numeroPaciente = null;
              this.modalCustomSize.dadosModal.descricaoNome = null;
              this.modalCustomSize.dadosModal.dataNascimento = null;
              this.modalCustomSize.dadosModal.dataNascimentoFormatada = null;
              this.modalCustomSize.dadosModal.descricaoTelefone = null;
              this.modalCustomSize.dadosModal.descricaoEndereco = null;
            }

            this.mostrarDadosPaciente = true;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    validarUnidade(unidade) {
      switch (unidade) {
        case "60":
          return true;
        case "61":
          return true;
        case "93":
          return true;
        case "97":
          return true;
        case "116":
          return true;
        case "119":
          return true;
        case "122":
          return true;
        case "128":
          return true;
        case "139":
          return true;
        case "127":
          return true;
        default:
          false;
      }
    },

    removerItemDaLista(value) {
      value.quantidadeDispensada = null;
      this.modalCustomSize.dadosModal.produtosDispensadosExcluidos.push(this.modalCustomSize.dadosModal.produtosDispensados.filter((item) => item.numeroItem == value.numeroItem)[0]);
      this.modalCustomSize.dadosModal.produtosDispensados = this.modalCustomSize.dadosModal.produtosDispensados.filter((item) => item.numeroItem != value.numeroItem);
    },
    //#endregion

    //#region FORMATADORES
    formataDataBanco(data) {
      if (data) {
        if (data.includes("T")) {
          const dataSeparada = data.split("T")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        } else if (data.includes(" ")) {
          const dataSeparada = data.split(" ")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        } else {
          const ano = data.split("-")[0];
          const mes = data.split("-")[1];
          const dia = data.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        }
      } else {
        return null;
      }
    },

    formataDataBancoTipoPadrao(data) {
      if (data) {
        if (data.includes("T")) {
          const dataSeparada = data.split("T")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        } else if (data.includes(" ")) {
          const dataSeparada = data.split(" ")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        } else {
          const ano = data.split("-")[0];
          const mes = data.split("-")[1];
          const dia = data.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        }
      } else {
        return null;
      }
    },

    formatarData(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    analizarData(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    corValidade(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        // var dia2  = dia.substring(0,2)

        const dataFormatada = ano + "-" + ("0" + mes).slice(-2) + "-" + dia;

        const dias = this.verificarDias(dataFormatada);

        if (store.state.numeroEndereco == 127 || store.state.numeroEndereco == "127" || store.state.numeroEndereco == 124 || store.state.numeroEndereco == "124") {
          if (dias > 90) {
            return "green";
          } else if (dias > 0 && dias <= 90) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        } else {
          if (dias > 30) {
            return "green";
          } else if (dias > 0 && dias <= 30) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual = new Date().toISOString().substr(0, 10);
      const daterecive = data;

      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual);
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24));

      return daysOfDiference;
    },

    formatarNome(nomeCompleto) {
      const palavras = nomeCompleto.split(" ");
      let iniciais = "";
      for (const palavra of palavras) {
        const inicial = palavra.charAt(0).toUpperCase();
        iniciais += inicial;
      }

      return iniciais;
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    //#endregion

    //#region VERIFICAÇÕES DE TOKENS
    async gerarNovoToken() {
      try {
        const response = await axios.post("/gerartoken", {}, this.config);

        await this.$store.dispatch("setToken", response.data.token);
        await this.$store.dispatch("setAuthenticatedState", true);

        if (response.data.token != this.config.headers["x-auth-token"]) {
          this.config.headers["x-auth-token"] = response.data.token;
        }

        this.inicializar();
      } catch (error) {
        console.log(error);
      }
    },

    async verificarToken() {
      try {
        await axios.post("/verifyToken", {}, this.config);
      } catch (error) {
        alert("Tempo de autenticação expirado, por favor realize o login novamente.");

        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    //#endregion
  },
};
</script>
